import React, {useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import {t} from "i18next";
import {Button, Drawer, Dropdown, Layout, Menu, Space,} from "antd";
import {DownOutlined, SearchOutlined} from "@ant-design/icons";
import swal from "sweetalert";
import {Util} from "common/util";
import {getHostURl} from "services/core";
import {changePassword, logout} from "services/auth";
import {Form, Input} from "common/elements";
import features from "./document";

import styles from "../style";
import {MICROSOFT_CONFIG} from "../../../components/Auth";

const { Header } = Layout;
const util = new Util();

export default function Headers() {
  const user = util.getCurrentUser();
  const navigate = useNavigate();
  let changPassworkRef = React.createRef();
  const [form] = Form.useForm();
  const [documents, setDocuments] = useState([])
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState('');


  React.useEffect(() => {
    const contentdropdown = document.getElementById('contentdropdown');
    window.addEventListener('click', function (e) {
      if (contentdropdown.contains(e.target)) {
        setStatus('none')
      } else {
        setStatus('none')
      }
    });
    // eslint-disable-next-line 
  }, []);


  const onChange = (e) => {
    const value = e.target.value.trim();
    if (value) {
      setStatus('block')
      const datas = features.filter(doc => doc.title.toLowerCase().includes(value.toLowerCase()) || doc.modules.title.toLowerCase().includes(value.toLowerCase()))
      setDocuments(datas)
    } else {
      setStatus('none')
      setDocuments([])
    }

    setSearch(e.target.value)
  }

  return (
    <Header style={styles.header} className='main-search-drop'>
      <div id="main-search-div"><Input prefix={<SearchOutlined />} placeholder="Search" style={{ width: 400, border: "none" }} value={search} onChange={onChange} id="search-module" /></div>
      <div className='content-dropdown' style={{ display: `${status}` }} id='contentdropdown'>
        <div className='header-title'>
          <p className='title'>Documentation</p>
        </div>
        <ul className='item' style={{ height: `${documents.length > 16 ? '80vh' : 'auto'}`, margin: `${documents.length > 16 ? '1rem 0' : '0'}` }}>
          {
            documents.length > 0 ? documents.map((value, index) => {
              return (
                <li className='text-title' key={index}>
                  <span className="first">{value.title}</span>
                  <span className="second"><Link to={value.modules.route}>{value.modules.title}</Link></span>
                </li>
              )
            }) :
              <li className='text-title'>{`No results found for search "${search}" `}</li>
          }
        </ul>
      </div>
      <div style={{ display: "flex" }}>
        <div id="non-printable">
          <img
            alt="Profile"
            src={util.getAuthSession().photo ? `${getHostURl()}/public/uploads/profile/${util.getAuthSession().photo}` : "/profile.png"}
            style={{ height: 40, borderRadius: "50%" }}
          />
        </div>
        {renderUserDropdown(navigate, user?.name, changPassworkRef, form)}
      </div>
    </Header>
  );
}

function renderUserDropdown(
  navigate,
  userName,
  changPassworkRef,
  form
) {
  const accessToken = JSON.parse(localStorage.getItem("ACCESS_TOKEN"));
  const employeeId = accessToken["profile"].id;
  const handleShowChangePasswordDrawer = (changPassworkRef) => changPassworkRef.showChangePassword();

  return (
    <>
      <Dropdown
        trigger={["hover"]}
        overlay={
          <Menu>
            <Menu.Item>
              <Link to={`/employees/profile/${employeeId}`}>
                {t("text_profile")}
              </Link>
            </Menu.Item>
            <Menu.Divider />
            <Menu.Item
              onClick={() => handleShowChangePasswordDrawer(changPassworkRef)}
            >
              {t("text_change_password")}
            </Menu.Item>
            <Menu.Item onClick={() => handleLogout(navigate)}>
              {t("text_log_out")}
            </Menu.Item>
          </Menu>
        }
      >
        <Space
          style={{ cursor: "pointer", padding: 5, color: "#000000" }}
          id="non-printable"
        >
          {userName ? userName : "Username"} <DownOutlined />
        </Space>
      </Dropdown>
      <ChangePassword
        ref={(f) => (changPassworkRef = f)}
        form={form}
        navigate={navigate}
      />
    </>
  );
}

class ChangePassword extends React.PureComponent {
  state = {
    visible: false,
    customValidate: {},
  };
  form = this.props.form;

  showChangePassword = () => {
    this.setState({
      visible: true,
    });
  };

  onClose = () => {
    this.setState({
      visible: false,
      loading: false,
      customValidate: {},
    });
    this.form.resetFields();
  };

  onFinish = (values) => {
    const Employee = JSON.parse(window.localStorage.getItem("ACCESS_TOKEN"));
    const id = Employee["userId"];
    const password = values["password"];
    const currentPassword = values["currentPassword"];
    this.setState({
      loading: true,
    });
    changePassword(id, password, currentPassword)
      .then(() => {
        logout();
        localStorage.removeItem("ACCESS_TOKEN");
        this.props.navigate("/signin");
      })
      .catch((error) => {
        if (error.response.status === 400) {
          this.setState({
            customValidate: {
              validateStatus: "error",
              help: t("text_your_current_password_does_not_match"),
            },
          });
        }
      })
      .finally(() => {
        this.setState({
          loading: false,
        });
      });
  };
  onChangeCurrentPassword = (event) => {
    if (!event.target.value) {
      this.setState({
        customValidate: {},
      });
    }
  };

  render() {
    const { visible, customValidate, loading } = this.state;
    return (
      <Drawer
        id="change-password"
        title={t("text_change_password")}
        placement="right"
        onClose={this.onClose}
        visible={visible}
      >
        <Form onFinish={this.onFinish} layout="vertical" form={this.form}>
          <Form.Item
            name="currentPassword"
            label={t("text_current_password")}
            {...customValidate}
            rules={[
              {
                required: true,
                message: t("text_please_input_your_current_password"),
              },
            ]}
          >
            <Input.Password
              onChange={(event) => this.onChangeCurrentPassword(event)}
              placeholder={t("text_please_enter_current_password")}
            />
          </Form.Item>
          <Form.Item
            name="password"
            label={t("text_new_password")}
            rules={[
              {
                required: true,
                message: t("text_please_input_your_new_password"),
              },
            ]}
            hasFeedback
          >
            <Input.Password placeholder={t("text_please_enter_new_password")} />
          </Form.Item>

          <Form.Item
            name="confirm"
            label={t("text_confirm_password")}
            dependencies={["password"]}
            hasFeedback
            rules={[
              {
                required: true,
                message: t("text_please_input_your_confirm_password"),
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error(t("text_your_confirm_password_does_not_match"))
                  );
                },
              }),
            ]}
          >
            <Input.Password
              placeholder={t("text_please_enter_new_password_again")}
            />
          </Form.Item>
          <Button
            type="primary"
            className="btn-submit-change-password"
            htmlType="submit"
            loading={loading}
          >
            {t("text_submit")}
          </Button>
        </Form>
      </Drawer>
    );
  }
}

function handleLogout(navigate) {
  swal({
    title: "Logout",
    text: "Are you sure you want to logout?",
    icon: "warning",
    buttons: {
      cancel: {
        text: "Cancel",
        visible: true,
        closeModal: true,
      },
      confirm: {
        text: "Logout",
        closeModal: false,
      }
    },
    dangerMode: true,
  }).then(async (willLogout) => {
    if (willLogout) {
      try {
        // Check if user logged in via Microsoft
        const accessToken = localStorage.getItem('ACCESS_TOKEN');
        let isMicrosoftLogin = false;

        if (accessToken) {
          try {
            const sessionData = JSON.parse(accessToken);
            isMicrosoftLogin = sessionData.loginMethod === 'microsoft';
          } catch (e) {
            console.warn('Failed to parse session data');
          }
        }

        if (isMicrosoftLogin) {
          // Microsoft login - use backend API and redirect to Microsoft logout
          console.log('🔓 Logging out from Microsoft account...');
          localStorage.clear();
          sessionStorage.clear();
          swal.close();
          window.location.href = `https://login.microsoftonline.com/${MICROSOFT_CONFIG.tenantId}/oauth2/v2.0/logout?post_logout_redirect_uri=${encodeURIComponent(window.location.origin + '/signin')}`;
        } else {
          // Regular login - use standard logout
          await logout().catch(() => {
            // Continue even if backend logout fails
          });
          localStorage.clear();
          sessionStorage.clear();
          navigate("/signin");
          swal.close();
        }
      } catch (error) {
        console.error('Logout error:', error);
        // Fallback: clear storage and navigate
        localStorage.clear();
        sessionStorage.clear();
        navigate("/signin");
        swal.close();
      }
    }
  });
}


